import {API} from '../../backend';
import { objectToQueryString } from '../../lib/utils';


export const getTax=(userId,token,taxId)=>{
  return fetch(`${API}/tax/${userId}/${taxId}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getTaxes=(userId,token,query)=>{
  let str=objectToQueryString(query)
  return fetch(`${API}/taxes/${userId}?${str}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}



export const addTax=(userId,token,body)=>{
  return fetch(`${API}/add-tax/${userId}`,{
    method:"POST",
    headers:{
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const updateTax=(userId,token,body,taxId)=>{
  return fetch(`${API}/update-tax/${userId}/${taxId}`,{
    method:"POST",
    headers:{
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}



export const getTaxCount=(userId,token,query)=>{
  let str=objectToQueryString(query)
  return fetch(`${API}/taxes-count/${userId}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const removeTax=(userId,token,taxId)=>{
  return fetch(`${API}/delete-tax/${userId}/${taxId}`,{
    method:"DELETE",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}